import { APP_CONFIG }                 from '@appConfig/_app-config_master';
import { RouteInfoOptions }           from '@core/interfaces/sidebar.interface';
import { ManageTenantIdentifierEnum } from '@shared/content-sections/manage-tenant/manage-tenant.model';

export interface IManageTenantMetadata {
	routeInfoOptionsMaps: {
		[ ManageTenantIdentifierEnum.ADMIN_CONSOLE_USER_DETAIL_PAGE_TENANT_ID_ACTION_TO_OVERVIEW ]: Map<string, RouteInfoOptions>;
		[ ManageTenantIdentifierEnum.ADMIN_CONSOLE_USER_DETAIL_PAGE_USER_ID_ACTION_TO_USER_DETAILS ]: Map<string, RouteInfoOptions>;
		[ ManageTenantIdentifierEnum.TENANT_DETAIL_PAGE ]: Map<string, RouteInfoOptions>;
		[ ManageTenantIdentifierEnum.TENANT_LIST_PAGE ]: Map<string, RouteInfoOptions>;

	};
}

const defaultRouteInfoOptionsMap: Map<string, RouteInfoOptions> = new Map( [
	// Hidden
	[ `/${ APP_CONFIG.accountTenant.route }`, { isVisible: false } ],
	[ `/${ APP_CONFIG.admin.route }`, { isVisible: false } ],
	[ `/${ APP_CONFIG.adminConsole.route }`, { isVisible: false } ],
	[ `/${ APP_CONFIG.contracts.route }`, { isVisible: false } ],
	[ `/${ APP_CONFIG.partnerTenant.route }`, { isVisible: false } ]
] );


export const MANAGE_TENANT_METADATA: IManageTenantMetadata = {
	routeInfoOptionsMaps: {
		[ ManageTenantIdentifierEnum.ADMIN_CONSOLE_USER_DETAIL_PAGE_TENANT_ID_ACTION_TO_OVERVIEW ]: defaultRouteInfoOptionsMap,
		[ ManageTenantIdentifierEnum.ADMIN_CONSOLE_USER_DETAIL_PAGE_USER_ID_ACTION_TO_USER_DETAILS ]: defaultRouteInfoOptionsMap,
		[ ManageTenantIdentifierEnum.TENANT_DETAIL_PAGE ]: defaultRouteInfoOptionsMap,
		[ ManageTenantIdentifierEnum.TENANT_LIST_PAGE ]: defaultRouteInfoOptionsMap
	}
};
